module.exports = __webpack_public_path__ + "static/media/ge.e2dd6543.svg";